import * as React from 'react';
import {ITranslatedComponent} from '../../redux/reducers/generalReducer';
import {connect, Dispatch} from 'react-redux';
import {translate} from 'react-i18next';
import Button from '../../components/Button';
import SelectField from '../../components/SelectField';
import {OptionDifferenceDto} from '../../services/Client';
import DataAdapterOptionsView from '../OptionsView/DataAdapterOptionsView';
import OptionDifferenceTable from './OptionDifferenceTable';
import OptionDifferenceService from '../../services/OptionDifferenceService';
import GeneralActions from "../../redux/actions/GeneralActions";
import {compose} from 'redux';
import {selectClient} from '../../redux/selectors';
import HATEOASClient from 'src/services/HATEOASClient';
import {IReduxState} from '../../redux/IReduxState';

interface IOptionDifferenceViewProps extends ITranslatedComponent {
    selectedOption: DataAdapterOptionsView;
    onClose: () => void;
    client: HATEOASClient;
    AddLoadingMessage: () => void;
    RemoveLoadingMessage: () => void;
}

interface IOptionDifferenceViewState {
    differences: OptionDifferenceDto | undefined;
    selectedRows: string[];
    rowKeys: string[];
}

class OptionDifferenceView extends React.Component<IOptionDifferenceViewProps, IOptionDifferenceViewState> {

    public constructor(props: IOptionDifferenceViewProps) {
        super(props);

        this.state = {
            differences: undefined,
            selectedRows: [],
            rowKeys: []
        };
    }

    componentDidMount() {
        this.props.AddLoadingMessage();

        const requestObject = this.props.client.GET_optionDifference(this.props.selectedOption.dto);
        if (requestObject.canExecute()) {
            requestObject.execute().then((res: OptionDifferenceDto) => {
                const keys: string[] = OptionDifferenceService.getKeys(res);

                this.setState(
                    {differences: res, rowKeys: keys, selectedRows: keys},
                    () => this.props.RemoveLoadingMessage()
                );
            }).catch(
                (err) => this.props.RemoveLoadingMessage()
            );
        } else {
            this.props.RemoveLoadingMessage();
        }
    }

    onSelectedRowsChange = (values: string[]) => {
        let keys: string[] = values.map((val: any) => val.selectedValue);
        this.setState({
            selectedRows: keys
        });
    }

    ModalContent = (): JSX.Element => {
        return (
            <>
                <section>
                    <SelectField
                        dataSource={this.state.rowKeys}
                        multi={true}
                        onChange={(values: string[]) => this.onSelectedRowsChange(values)}
                        value={this.state.rowKeys}
                        rendererKey={(value: string) => {
                            return this.props.t(OptionDifferenceService.keyToLabel(value));
                        }}
                    />
                </section>

                <section className='scroll'>
                    {this.state.differences !== undefined ?
                        <OptionDifferenceTable differences={this.state.differences} selectedKeys={this.state.selectedRows} /> : <> Loading ... </>}
                </section>
            </>
        );
    }

    ModalNoChanges = (): JSX.Element => {
        const t = this.props.t;

        return (
            <section className='no-differences'>
                <h3>
                    {t('OPTIONS_VIEW:NO_DIFFERENCES')}
                </h3>
            </section>
        );
    }

    render() {
        const t = this.props.t;

        let optionCode: string = this.state.differences ? this.state.differences.optionCode : '-';
        let optionType: string = this.state.differences ? this.state.differences.optionType : '-';

        return (

            <div className='difference-view'>
                <div className='difference-view-modal'>
                    <Button className='close-btn' onClick={this.props.onClose} icon='close' />

                    <header>
                        <h1> {t('OPTIONS_VIEW:COMPARE_VIEW')} </h1>
                        <h2>
                            <span> {optionCode} </span>
                            <span>-</span>
                            <span> {optionType} </span>
                        </h2>
                    </header>

                    {this.state.rowKeys.length !== 0 ? <this.ModalContent /> : <this.ModalNoChanges />}

                    <footer>
                        <Button
                            label={t('CLOSE')}
                            labelPosition="after"
                            onClick={this.props.onClose}
                        />
                    </footer>
                </div>
            </div>
        );

    }
}

const mapStateToProps = (state: IReduxState) => ({
    client: selectClient(state)
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>) => {
    const modifiingMessage = 'Loading the options for comparation';

    return {
        AddLoadingMessage: () => dispatch(GeneralActions.AddLoadingMessage(modifiingMessage)),
        RemoveLoadingMessage: () => dispatch(GeneralActions.RemoveLoadingMessage(modifiingMessage))
    };
};

export default compose<React.ComponentType<any>>(
    translate(["COLUMN_FACTORY", "OPTIONS_VIEW"]),
    connect(mapStateToProps, mapDispatchToProps)
)(OptionDifferenceView);



// WEBPACK FOOTER //
// ./src/views/OptionDifferenceView/OptionDifferenceView.tsx